export default __webpack_public_path__ + "static/media/honor.21c9f82c.png";